import { Skeleton } from "@/components/ui/skeleton";
import { TableRow, TableCell } from "@/components/ui/table";

export const LoadingAppTable = () => {
  return Array.from({ length: 3 }).map((_, i) => {
    return (
      // eslint-disable-next-line react/no-array-index-key
      <TableRow key={i} data-testid="appRowLoading">
        <TableCell className="w-16">
          <Skeleton className="h-12" />
        </TableCell>
        <TableCell>
          <Skeleton className="h-12" />
        </TableCell>
        <TableCell>
          <Skeleton className="h-12" />
        </TableCell>
        <TableCell>
          <Skeleton className="h-12" />
        </TableCell>
      </TableRow>
    );
  });
};
